import React from 'react';
import { Helmet } from 'react-helmet';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <Helmet>
        <title>Terms of Service - IRS Audit Protection</title>
        <meta name="description" content="Terms of Service for IRS Audit Protection services" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using IRS Audit Protection services, you agree to be bound by these Terms of Service 
                and all applicable laws and regulations. If you do not agree with any of these terms, you are 
                prohibited from using or accessing our service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Service Description</h2>
              <p className="mb-4">
                IRS Audit Protection provides audit protection services through a monthly subscription model. 
                Our service includes:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Coverage for tax attorney fees up to policy limits</li>
                <li>Access to tax professionals</li>
                <li>Document review and storage</li>
                <li>Audit response assistance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Subscription and Billing</h2>
              <p className="mb-4">
                By subscribing to our service, you agree to the following terms:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Monthly subscription fees will be automatically charged</li>
                <li>Subscription can be canceled at any time</li>
                <li>No refunds for partial months of service</li>
                <li>Price changes will be notified 30 days in advance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Coverage Limitations</h2>
              <p className="mb-4">Our service does not cover:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Pre-existing audits or investigations</li>
                <li>Criminal tax matters</li>
                <li>Willful negligence or fraud</li>
                <li>Non-filed returns</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. User Responsibilities</h2>
              <p className="mb-4">As a user, you are responsible for:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Providing accurate information</li>
                <li>Maintaining account security</li>
                <li>Timely notification of any audit notices</li>
                <li>Cooperating with tax professionals</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Disclaimer</h2>
              <p>
                This service is not affiliated with the Internal Revenue Service (IRS). We provide protection 
                services through licensed tax attorneys but do not guarantee the outcome of any audit or investigation.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Contact Information</h2>
              <p>
                For questions about these Terms of Service, please contact us at:{' '}
                <a href="mailto:legal@irsaudit.com" className="text-primary-600 hover:text-primary-700">
                  legal@irsaudit.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 